import {
    Container, Grid, Button, Typography
} from '@mui/material'

import { useNavigate } from 'react-router-dom'

import { generateUrl } from '../../services/routes'
import { ROUTE_LOADER } from '../../features/routes'

import img404 from '../media/404.png'

export const NotFound = () => {
    const navigate = useNavigate()

    const redirectToHome = (event) => {
        event.preventDefault()
        navigate(generateUrl(ROUTE_LOADER))
    }

    return (
        <Container maxWidth={'lg'} sx={{paddingTop: '30px', paddingBottom: '30px'}}>
            <Grid container>
                <Grid item xs={6}>
                    <img src={img404} alt="404"/>
                </Grid>
                <Grid item xs={6} textAlign={'center'}>
                    <Grid container flexDirection={'row'} alignContent={'center'} height={'100%'}>
                        <Grid item xs={12} textAlign={'left'}>
                            <Typography variant={'h1'}>Page not found</Typography>
                            <Typography variant={'body2'} sx={{mt: 1}}>The page you are looking for does not exist or is temporarily unavailable.</Typography>
                            <Button onClick={redirectToHome} sx={{mt: 3}}>
                                Back to home
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )
}

export default NotFound